/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-12 10:52:29
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-17 20:00:55
 * @FilePath: /locationpms-pc/src/utils/merge.ts
 * @Description:
 *
 *
 */
export default function (target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var i = 0, j = args.length; i < j; i++) {
        var source = args[i] || {};
        for (var prop in source) {
            if (source[prop] !== undefined) {
                var value = source[prop];
                if (value !== undefined) {
                    target[prop] = value;
                }
            }
        }
    }
    return target;
}
